import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthentService, AuthenticationRole } from './authent.service';

@Injectable({
  providedIn: 'root'
})
export class InternalAuthGuardService implements CanActivate{

  constructor(
    private authService: AuthentService,
    private router: Router,
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot){
    if(this.authService.currentUser()?.ROLE == AuthenticationRole.InternalAdmin || this.authService.currentUser()?.ROLE == AuthenticationRole.InternalUser){
      return true;
    }
    this.router.navigate(["/home"], {queryParams: {return: state.url }});
    return false;
  }
}
